globalThis.Block = class Block {
  static of(index) {
    return new Block(0, 0, index);
  }

  constructor(x, y, index = 0) {
    this.index = index;
    this.size = new Vector2(1, 1);
    this.position = new Vector2(x, y);
    this.div = document.createElement("div");
    this.div.classList.add("block");
    this.render();
  }

  remove() {
    this.div.remove();
  }

  update(update) {
    Object.assign(this, update);
    this.render();
  }

  render() {
    this.div.style.setProperty("--x", this.position.x);
    this.div.style.setProperty("--y", this.position.y);
    this.setSpritePosition(this.index % 8, Math.floor(this.index / 8));
  }

  setSpritePosition(x, y) {
    this.div.style.setProperty("--sprite-x", x);
    this.div.style.setProperty("--sprite-y", y);
  }
};
